import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useRollbarContext } from '@services/rollbar';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData, useGetClientSideData } from '@services/dataHandler/getPageData';
import ReduxWrapper from '@services/store';
import { isModalClosed } from '@services/dataHandler/utils';
import { selectSerieDetail } from '@features/serieDetail/slices/serieDetailServerSlice';
import SerieSubscriptionsTemplate from '@features/serieDetail/templates/SerieSubscriptionsTemplate';
import { MODAL_NAME } from '@features/ui-layout/templates/ModalContainer';

const SerieSubscriptionsPage = () => {
  useRollbarContext('Series : SubscriptionsPage');

  const modalClosed = isModalClosed([MODAL_NAME.subscriptionCartCreate, MODAL_NAME.menu]);
  const isLoading = useGetClientSideData(GET_DATA_FOR.SERIE_SUBSCRIPTIONS, [modalClosed]);

  const { t } = useTranslation();
  const serie = useSelector(selectSerieDetail);

  return (
    <>
      <Head>
        <title>
          {`${t('head_SerieSubscriptionsTitle.message', { serieName: serie?.name })} ${t('head_siteTitle.message')}`}
        </title>
        <meta
          name="description"
          content={
            t('head_SerieSubscriptionsDescription.message',
              {
                serieName: serie?.name,
                earliest: serie?.serieDates.earliestEventDate,
                latest: serie?.serieDates.latestEventDate,
                serieSport: serie?.serieCategory,
              })
          }
        />
      </Head>
      <SerieSubscriptionsTemplate isLoading={isLoading} />
    </>
  );
};

export default SerieSubscriptionsPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.SERIE_SUBSCRIPTIONS
      );
    },
  })
);
